import { GetterTree } from 'vuex';
import { RootState } from '@/interface/store/';
import { Inventory } from '@/interface/store/inventory';

export const getters: GetterTree<Inventory, RootState> = {
  getterDataList: (state) => state.dataList,
  getterDataTotalCount: (state) => state.totalCount,
  getterQueryParams: (state) => state.queryParams,
  getterInventoryItem: (state) => state.inventoryItem,
  getterAttachments: (state) => state.inventoryAttachments,
  getterInventoryHistories: (state) => state.inventoryHistories,
  getterInventoryFilter: (state) => state.inventoryFilter,
  getterInventoryFilterStack: (state) => state.inventoryFilterStack,
};
